export let Transformer = {
  transformerId: '',
  hyperParams: [],
  deletable: false,
  hasError: '',
  use: false
}

export let TransformerSummary = {
  transformerId: '',
  transformerName: '',
  description: {
    text: '',
    imgUrl: ''
  },
  hyperParams: [],
  rules: []
}

export let TransformersCategory = {
  categoryId: '',
  categoryName: '',
  transformers: []
}

export let TransformerPackages = {
  packages: [],
  transformers: [],
  default: ''
}

export let TransformerPackage = {
  packageId: '',
  packageName: '',
  transformerIds: [],
  transformers: [],
  defaultOptions: [],
  tip: ''
}

export let ModelTransformersPackage = Object.assign({
  transformers: []
}, TransformerPackage)

export let TransformerPackageDefaultOption = {
  transformerId: '',
  defaultHyperParams: []
}

export let TransformerRestrictionRuleValue = {
  oneOf: [],
  allOf: []
}

export let TransformerRestrictionRule = {
  required: false,
  once: false,
  before: {
    required: TransformerRestrictionRuleValue | [],
    allowed: [],
    denied: []
  },
  conditions: {
    includes: TransformerRestrictionRuleValue | [],
    algorithms: [],
    categories: []
  }
}



// WEBPACK FOOTER //
// ./src/defines/transformer.js